export default __webpack_public_path__ + "static/media/sirius_star.f688cdb0.png";